import { FC } from 'react';
import { PageContainer } from '@edikk-edikk/country-layout-black';
import { useHomeContext } from '#home/hooks';
import { SeoBlock } from '#components/seo-block';

const SeoTextLong: FC = () => {
  const { seo } = useHomeContext();

  if (!seo.textLong) {
    return null;
  }

  return (
    <PageContainer>
      <SeoBlock text={seo.textLong} linkList={seo.linkList} />
    </PageContainer>
  );
};

export { SeoTextLong };
